import { render, staticRenderFns } from "./SidebarFilterUsedPrivilege.vue?vue&type=template&id=f8601848&scoped=true"
import script from "./SidebarFilterUsedPrivilege.vue?vue&type=script&lang=js"
export * from "./SidebarFilterUsedPrivilege.vue?vue&type=script&lang=js"
import style0 from "./SidebarFilterUsedPrivilege.vue?vue&type=style&index=0&id=f8601848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8601848",
  null
  
)

export default component.exports